module.exports = __webpack_public_path__ + "img/duct_rounded_corner.6832b0a6.svg";